module.exports = __webpack_public_path__ + "img/app-logo.498c6028.png";